import { Component, OnInit, OnDestroy, Input } from '@angular/core';

import { ISubscription } from 'rxjs/Subscription';

import Handsontable from 'handsontable';
import { HotRegisterer } from 'angular-handsontable';
import {Report} from '../shared/report.model';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-functional-categories',
  templateUrl: './functional-categories.component.html',
  styleUrls: ['./functional-categories.component.css']
})
export class FunctionalCategoriesComponent implements OnInit, OnDestroy {
  columns: Array<Object>;
  report: Report;
  data: any;
  reloadSubscription: ISubscription;

  constructor(private reportService: ReportDataService, private gridContext: HotRegisterer) {
  }

  ngOnInit() {
    this.report = this.reportService.getReport();
    this.columns = this.report.FunctionalCategories.columns;
    this.data = this.report.FunctionalCategories.data;
    this.reloadSubscription = this.reportService.getReload().subscribe(data => this.reload());
  }

  ngOnDestroy() {
    this.reloadSubscription.unsubscribe();
  }

  reload() {
    this.data = this.report.FunctionalCategories.data;
    const gridInstance = this.gridContext.getInstance('FunctionalCategories');
    gridInstance.loadData(this.data);
  }
}


// WEBPACK FOOTER //
// ./src/app/functional-categories/functional-categories.component.ts